import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'
import { useTokenStore } from '@/stores/token'

export const useTokenSwitcher = () => {
  const tokenStore = useTokenStore()
  const saveToken = (name: ELocalStorageKey, token: string) => {
    localStorage.setItem(name, token)
  }

  const getValueToken = () => localStorage.getItem(ELocalStorageKey.TOKEN_VALUE)

  const setValueToken = (token: string) => {
    tokenStore.setToken(token)
    localStorage.setItem(ELocalStorageKey.TOKEN_VALUE, token)
  }

  const setMainToken = (token: string) => {
    localStorage.setItem(ELocalStorageKey.TOKEN_ACTIVE_KEY, ELocalStorageKey.TOKEN_MAIN)
    saveToken(ELocalStorageKey.TOKEN_VALUE, token)
  }

  const setSendToken = (token: string) => {
    const prevToken = localStorage.getItem(ELocalStorageKey.TOKEN_VALUE) || ''
    setValueToken(token)
    saveToken(ELocalStorageKey.TOKEN_PREVIOUS_VALUE, prevToken)
    localStorage.setItem(ELocalStorageKey.TOKEN_ACTIVE_KEY, ELocalStorageKey.TOKEN_SEND_PACKAGE)
  }

  const resetTokenMain = () => {
    const tokenActive = localStorage.getItem(ELocalStorageKey.TOKEN_ACTIVE_KEY)

    if (tokenActive !== ELocalStorageKey.TOKEN_MAIN) {
      const prevToken = localStorage.getItem(ELocalStorageKey.TOKEN_PREVIOUS_VALUE) || ''
      localStorage.removeItem(ELocalStorageKey.TOKEN_PREVIOUS_VALUE)
      setValueToken(prevToken)
      localStorage.setItem(ELocalStorageKey.TOKEN_ACTIVE_KEY, ELocalStorageKey.TOKEN_MAIN)
    }
  }

  return {
    saveToken,
    setMainToken,
    setSendToken,
    setValueToken,
    getValueToken,
    resetTokenMain
  }
}
